export default __webpack_public_path__ + "static/media/ko_KR.0f2765d5.svg";